import React, { useState } from "react";
import { Main } from "./routes/Main";
import { Routes, Route } from "react-router-dom";
import { Contact } from "./routes/Contact";
import { Imprint } from "./routes/Imprint";
import { Bricklaying } from "./routes/Bricklaying";
import { TileWork } from "./routes/TileWork";
import { Concrete } from "./routes/Concrete";
import { Reference } from "./routes/Reference";
import { AppContext } from "../src/AppContext";
import { Review } from "./routes/Review";
import { Blog } from "./routes/Blog";
import { BlogArticle } from "./components/blog/BlogArticel";
import { CbdForAnimals } from "./components/blog/articles/CbdForAnimals";
import { articles } from "./components/blog/BlogContent";
import { Reviews } from "./routes/Reviews";
import { Datasecruity } from "./routes/Datasecruity";

function App() {
  const [reference, setReference] = useState({
    title: "Beton,- und Betonsanierungsarbeiten",
    images: undefined,
  });

  return (
    <AppContext.Provider value={[reference, setReference]}>
      <Routes>
        <Route path="*" element={<Main />} />
        <Route path="/" element={<Main />} />
        {/* <Route path="/kontakt" element={<Contact />} />
        <Route path="/impressum" element={<Imprint />} />
        <Route path="/maurerarbeiten" element={<Bricklaying />} />
        <Route path="/fliesenarbeiten" element={<TileWork />} />
        <Route path="/stahl-betonbau" element={<Concrete />} />
        <Route path="/bewertung" element={<Review />} />
        <Route path="/bewertungen" element={<Reviews />} />
        <Route path="/datenschutz" element={<Datasecruity />} />
        <Route
          path="/referenzen"
          element={
            <Reference title={reference.title} images={reference.images} />
          }
        />
        <Route path="/blog" element={<Blog />} />
        <Route
          path={articles[0].link}
          element={
            <BlogArticle article={articles[0]}>
              <CbdForAnimals />
            </BlogArticle>
          }
        /> */}
      </Routes>
    </AppContext.Provider>
  );
}

export default App;
